

import type { TIllustrationAssetProps } from "../helper";
import { ILLUSTRATION_COLOR_TOKEN_MAP } from "../helper";

export function PageVerticalStackIllustration({
  className,
}: TIllustrationAssetProps) {
  return (
    <svg
      width="162"
      height="177"
      viewBox="0 0 162 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2958 52.3993C13.0691 51.7747 11.4935 51.8254 9.76603 52.7088C5.86647 54.6952 2.70968 60.1534 2.70968 64.8914C2.70968 67.5362 3.69442 69.4043 5.24186 70.1921L2.73219 68.9148C1.18475 68.127 0.200012 66.2588 0.200012 63.6141C0.200012 58.8705 3.36241 53.4122 7.25634 51.4315C8.97823 50.5537 10.5594 50.4974 11.7861 51.122L14.2958 52.3993Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2957 52.3996C15.8432 53.1874 16.8279 55.0556 16.8279 57.7003C16.8279 62.4439 13.6655 67.9022 9.77156 69.8829C8.04968 70.7607 6.46848 70.817 5.24178 70.1924C3.69433 69.4046 2.70959 67.5364 2.70959 64.8917C2.70959 60.1481 5.87201 54.6898 9.76594 52.7091C11.4878 51.8313 13.069 51.775 14.2957 52.3996Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4541 62.0109C11.6511 61.6732 11.9155 61.4031 12.1969 61.2568L13.7837 60.4465C13.975 60.3509 14.1326 60.4578 14.1326 60.6941C14.1326 60.9305 13.975 61.2006 13.7837 61.2962L12.1969 62.1065C12.1068 62.1515 12.0168 62.2416 11.9493 62.3597C11.8818 62.4779 11.848 62.6017 11.848 62.7142V64.6443C11.848 64.8807 11.6904 65.1508 11.4991 65.2464C11.3078 65.3421 11.1502 65.2352 11.1502 64.9988V63.0687C11.1502 62.7311 11.2628 62.3485 11.4597 62.0109H11.4541Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70253 58.0775C8.89385 57.9819 9.05141 58.0888 9.05141 58.3251V59.0341C9.05141 59.2592 9.12457 59.4393 9.25399 59.5293C9.38341 59.6194 9.56348 59.6194 9.74917 59.5293C10.0249 59.3886 10.295 59.3886 10.4919 59.5293C10.6889 59.67 10.8014 59.9345 10.8014 60.2777C10.8014 60.5084 10.959 60.621 11.1503 60.5253C11.2403 60.4803 11.3304 60.3903 11.3979 60.2721C11.4654 60.1596 11.4992 60.0301 11.4992 59.9176C11.4992 59.2142 11.9719 58.3983 12.5458 58.1057L13.6544 57.543C13.8457 57.4473 14.0032 57.5542 14.0032 57.7906C14.0032 58.0269 13.8457 58.297 13.6544 58.3927L12.5458 58.9554C12.3545 59.051 12.1969 59.3267 12.1969 59.5575C12.1969 59.8951 12.0844 60.2777 11.8875 60.6153C11.6905 60.953 11.426 61.2231 11.1447 61.3694C10.5651 61.662 10.098 61.33 10.098 60.6266C10.098 60.5141 10.0587 60.424 9.99677 60.379C9.93487 60.334 9.84483 60.334 9.74917 60.379C9.37779 60.5703 9.02328 60.5703 8.7588 60.379C8.49433 60.1933 8.34802 59.8332 8.34802 59.383V58.674C8.34802 58.4377 8.50558 58.1676 8.6969 58.0719L8.70253 58.0775Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.62048 62.8213C6.62048 62.5849 6.77804 62.3148 6.96936 62.2192L7.9991 61.6958C8.27483 61.5552 8.54493 61.5552 8.74188 61.6958C8.93883 61.8365 9.05136 62.101 9.05136 62.4442V62.8719C9.05136 62.9844 9.09077 63.0745 9.15266 63.1195C9.22019 63.1645 9.30458 63.1645 9.40024 63.1195C9.67597 62.9788 9.94607 62.9788 10.143 63.1195C10.34 63.2602 10.4525 63.5246 10.4525 63.8679V65.5504C10.4525 65.7867 10.2949 66.0568 10.1036 66.1525C9.9123 66.2481 9.75475 66.1412 9.75475 65.9049V64.2224C9.75475 64.1099 9.71536 64.0198 9.65346 63.9748C9.58594 63.9298 9.50153 63.9298 9.40587 63.9748C9.13015 64.1155 8.86004 64.1155 8.66309 63.9748C8.46615 63.8341 8.35361 63.5697 8.35361 63.2264V62.7987C8.35361 62.6862 8.31423 62.5962 8.25233 62.5512C8.1848 62.5061 8.1004 62.5061 8.00474 62.5512L6.97497 63.0745C6.78365 63.1701 6.6261 63.0632 6.6261 62.8269L6.62048 62.8213Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4469 57.4696C8.70812 58.353 7.30136 60.7895 7.30136 62.9053C7.30136 65.0211 8.70812 66.0171 10.4469 65.1336C12.1857 64.2502 13.5924 61.8136 13.5924 59.6979C13.5924 57.5821 12.1857 56.5861 10.4469 57.4696ZM6.60361 63.2598C6.60361 60.677 8.32549 57.7003 10.4525 56.6199C12.5796 55.5395 14.3014 56.7549 14.3014 59.3434C14.3014 61.9318 12.5796 64.9029 10.4525 65.9833C8.32549 67.0637 6.60361 65.8483 6.60361 63.2598Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <g opacity="0.2">
        <path
          d="M0.65564 139.889C0.65564 142.016 2.24809 144.137 5.42738 145.764L46.3643 166.623C52.7285 169.864 63.0429 169.864 69.4072 166.623L155.428 122.794C158.607 121.173 160.2 119.052 160.2 116.925V123.717C160.2 125.844 158.607 127.965 155.428 129.586L69.4072 173.415C63.0429 176.656 52.7285 176.656 46.3643 173.415L5.42738 152.556C2.24246 150.935 0.65564 148.808 0.65564 146.681V139.889Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.655701 139.889C0.655701 137.762 2.24815 135.641 5.42744 134.02L91.4484 90.1908C97.8126 86.9496 108.127 86.9496 114.491 90.1908L155.428 111.05C158.613 112.671 160.2 114.798 160.2 116.925C160.2 119.052 158.607 121.173 155.428 122.794L69.4072 166.623C63.043 169.864 52.7286 169.864 46.3644 166.623L5.42744 145.764C2.24252 144.143 0.655701 142.016 0.655701 139.889Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.6">
        <path
          d="M0.65564 118.433C0.65564 120.56 2.24809 122.682 5.42738 124.308L46.3643 145.167C52.7285 148.409 63.0429 148.409 69.4072 145.167L155.428 101.338C158.607 99.7176 160.2 97.5961 160.2 95.4691V102.261C160.2 104.388 158.607 106.509 155.428 108.13L69.4072 151.959C63.0429 155.2 52.7285 155.2 46.3643 151.959L5.42738 131.1C2.24246 129.479 0.65564 127.352 0.65564 125.225V118.433Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.655701 118.433C0.655701 116.306 2.24815 114.185 5.42744 112.564L91.4484 68.7348C97.8126 65.4937 108.127 65.4937 114.491 68.7348L155.428 89.5944C158.613 91.215 160.2 93.342 160.2 95.469C160.2 97.5961 158.607 99.7175 155.428 101.338L69.4072 145.167C63.043 148.408 52.7286 148.408 46.3644 145.167L5.42744 124.308C2.24252 122.687 0.655701 120.56 0.655701 118.433Z"
          fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
          stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
          strokeWidth="0.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M0.655701 96.977C0.655701 99.104 2.24815 101.225 5.42744 102.852L46.3644 123.711C52.7286 126.952 63.043 126.952 69.4072 123.711L155.428 79.882C158.607 78.2614 160.2 76.14 160.2 74.0129V80.8048C160.2 82.9318 158.607 85.0532 155.428 86.6738L69.4072 130.503C63.043 133.744 52.7286 133.744 46.3644 130.503L5.42744 109.644C2.24252 108.023 0.655701 105.896 0.655701 103.769V96.977Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.655762 96.9769C0.655762 94.8499 2.24821 92.7285 5.4275 91.1079L91.4485 47.2787C97.8127 44.0375 108.127 44.0375 114.491 47.2787L155.428 68.1382C158.613 69.7588 160.2 71.8858 160.2 74.0129C160.2 76.1399 158.608 78.2613 155.428 79.8819L69.4073 123.711C63.0431 126.952 52.7286 126.952 46.3644 123.711L5.4275 102.852C2.24258 101.231 0.655762 99.104 0.655762 96.9769Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.552 97.3814C67.9049 97.3814 67.2972 97.2407 66.7514 96.9594L61.7377 94.4047C60.1677 93.6057 59.2674 91.7712 59.2674 89.3741V30.6275C59.2674 26.3903 62.1147 21.4892 65.6091 19.7054L92.7653 5.86842C92.8441 5.82903 92.9341 5.80652 93.0186 5.80652C93.103 5.80652 93.193 5.82903 93.2717 5.86842L98.2855 8.4231C98.2855 8.4231 98.3305 8.45124 98.353 8.46249L113.439 19.1314C113.591 19.2383 113.675 19.4071 113.675 19.5928V67.3273C113.675 71.5644 110.828 76.4656 107.334 78.2494L71.1236 96.7005C70.2345 97.1507 69.368 97.3814 68.5408 97.3814H68.552Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
      />
      <path
        d="M93.0241 6.36943L98.0378 8.92412L113.124 19.593V67.3275C113.124 71.3846 110.423 76.0494 107.086 77.7488L70.876 96.1999C70.0488 96.622 69.261 96.8189 68.5464 96.8189C67.9837 96.8189 67.466 96.6951 67.0046 96.4588L61.9909 93.9041C60.6685 93.2288 59.8301 91.6364 59.8301 89.3743V30.6277C59.8301 26.5706 62.5311 21.9058 65.8623 20.2064L93.0185 6.36943M93.0241 5.24402C92.8497 5.24402 92.6753 5.28341 92.5121 5.36781L65.3558 19.2048C61.6251 21.1067 58.7047 26.1204 58.7047 30.6277V89.3743C58.7047 91.9909 59.7175 94.011 61.4844 94.9057L66.4981 97.4604C67.1227 97.7812 67.8149 97.9387 68.552 97.9387C69.4692 97.9387 70.4258 97.6911 71.3937 97.1959L107.604 78.7448C111.335 76.8428 114.255 71.8291 114.255 67.3218V19.5987C114.255 19.2329 114.081 18.8897 113.777 18.6815L98.6906 8.01254C98.6456 7.97877 98.6005 7.95064 98.5499 7.92813L93.5362 5.37344C93.373 5.28903 93.1986 5.24965 93.0241 5.24965V5.24402Z"
        fill="var(--illustration-stroke-tertiary)"
      />
      <path
        d="M98.0378 8.92383L70.8816 22.7608C67.5503 24.4602 64.8494 29.125 64.8494 33.1821V91.9287C64.8494 94.1908 65.6878 95.7833 67.0101 96.4585L61.9964 93.9038C60.6741 93.2286 59.8356 91.6361 59.8356 89.374V30.6274C59.8356 26.5703 62.5366 21.9055 65.8679 20.2061L93.0241 6.36914L98.0378 8.92383Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.tertiary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.secondary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.0376 8.92383L113.124 19.5984V67.3328C113.124 71.3899 110.423 76.0547 107.092 77.7541L70.8814 96.2053C69.4071 96.9537 68.0566 96.9987 67.01 96.4697C65.6876 95.7945 64.8492 94.202 64.8492 91.94V33.1934C64.8492 29.1363 67.5502 24.4714 70.8814 22.772L98.0376 8.93508V8.92383Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.secondary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.0377 8.92383V19.9416C98.0377 23.9987 100.739 25.9063 104.07 24.2126L113.124 19.5984"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
      />
      <path
        d="M98.0377 8.92383V19.9416C98.0377 23.9987 100.739 25.9063 104.07 24.2126L113.124 19.5984"
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.secondary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.5306 66.0128L76.233 74.8248C75.1638 75.3706 74.2972 74.7572 74.2972 73.4574C74.2972 72.1575 75.1638 70.6664 76.233 70.1205L93.5306 61.3086C94.5997 60.7627 95.4663 61.3761 95.4663 62.6759C95.4663 63.9758 94.5997 65.467 93.5306 66.0128Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        d="M101.735 47.6831L76.233 60.676C75.1639 61.2218 74.2973 60.6084 74.2973 59.3086C74.2973 58.0087 75.1639 56.5176 76.233 55.9717L101.735 42.9788C102.804 42.433 103.671 43.0464 103.671 44.3462C103.671 45.6461 102.804 47.1372 101.735 47.6831Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.028 6.86407C138.254 6.23946 139.83 6.29011 141.557 7.17356C145.457 9.15991 148.614 14.6182 148.614 19.3562C148.614 22.0009 147.629 23.8691 146.082 24.6569L148.591 23.3795C150.139 22.5917 151.123 20.7235 151.123 18.0788C151.123 13.3352 147.961 7.87694 144.067 5.89621C142.345 5.01839 140.764 4.96212 139.537 5.58672L137.028 6.86407Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.028 6.86443C135.48 7.65222 134.495 9.52041 134.495 12.1651C134.495 16.9088 137.658 22.367 141.552 24.3477C143.274 25.2256 144.855 25.2818 146.082 24.6572C147.629 23.8694 148.614 22.0012 148.614 19.3565C148.614 14.6129 145.451 9.15465 141.557 7.17392C139.836 6.2961 138.254 6.23983 137.028 6.86443Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.911 11.653C137.911 11.3941 138.086 11.2703 138.294 11.3829L145.221 14.911C145.435 15.0179 145.603 15.3162 145.603 15.575C145.603 15.8339 145.429 15.9577 145.221 15.8451L138.294 12.317C138.08 12.21 137.911 11.9118 137.911 11.653ZM137.911 13.9938C137.911 13.735 138.086 13.6112 138.294 13.7237L142.143 15.6876C142.357 15.7945 142.525 16.0927 142.525 16.3516C142.525 16.6104 142.351 16.7342 142.143 16.6217L138.294 14.6578C138.08 14.5509 137.911 14.2527 137.911 13.9938ZM138.299 15.5975C138.086 15.4906 137.917 15.6088 137.917 15.8676C137.917 16.1265 138.091 16.4247 138.299 16.5316L140.995 17.9046C141.209 18.0115 141.377 17.8934 141.377 17.6345C141.377 17.3757 141.203 17.0775 140.995 16.9705L138.299 15.5975ZM137.911 17.7415C137.911 17.4826 138.086 17.3588 138.294 17.4714L139.836 18.2535C140.049 18.3604 140.218 18.6587 140.218 18.9175C140.218 19.1764 140.044 19.3001 139.836 19.1876L138.294 18.4054C138.08 18.2985 137.911 18.0003 137.911 17.7415ZM144.697 17.6908C144.838 17.764 144.973 17.899 145.069 18.0678C145.17 18.2366 145.221 18.428 145.221 18.6024C145.221 18.7768 145.164 18.9063 145.069 18.9794L144.838 19.1426L144.095 17.854L144.326 17.6908C144.427 17.6233 144.557 17.6233 144.697 17.6908ZM143.881 18.0003L144.624 19.2889L142.936 20.4818C142.812 20.5719 142.66 20.6 142.492 20.5775L141.951 20.4987C141.951 20.4987 141.895 20.4818 141.873 20.4593C141.844 20.4368 141.822 20.4087 141.805 20.3749C141.788 20.3412 141.771 20.3074 141.766 20.268C141.76 20.2342 141.76 20.2005 141.766 20.1723L141.929 19.5984C141.98 19.4183 142.07 19.2776 142.193 19.1932L143.881 18.0003Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44199 40.8974C6.81176 40.5766 6.41223 39.817 6.41223 38.7366V24.939C6.41223 23.0033 7.70084 20.775 9.2933 19.9647L44.997 1.77236C45.7004 1.41223 46.3475 1.39535 46.8483 1.64857L44.3387 0.371221C43.8379 0.118003 43.1908 0.134884 42.4874 0.495016L6.78361 18.6873C5.19115 19.4976 3.90256 21.7259 3.90256 23.6617V37.4592C3.90256 38.5396 4.30209 39.2993 4.93232 39.62L7.44199 40.8974Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.secondary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44181 40.8976C7.94262 41.1508 8.58974 41.1339 9.29312 40.7738L44.9969 22.5815C46.5893 21.7712 47.8779 19.5429 47.8779 17.6072V3.8096C47.8779 2.72921 47.4784 1.96955 46.8482 1.64881C46.3474 1.39559 45.7002 1.41247 44.9969 1.7726L9.29312 19.9649C7.70066 20.7752 6.41205 23.0035 6.41205 24.9392V38.7368C6.41205 39.8172 6.81158 40.5769 7.44181 40.8976Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.primary}
        stroke={ILLUSTRATION_COLOR_TOKEN_MAP.stroke.primary}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8699 20.3929C28.8699 20.151 28.7067 20.0384 28.5098 20.1397L24.9028 21.9798C24.7059 22.0811 24.5427 22.3624 24.5427 22.6044C24.5427 22.8463 24.7059 22.9589 24.9028 22.8576L28.5098 21.0176C28.7067 20.9163 28.8699 20.6349 28.8699 20.3929Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5902 22.6604C29.5902 22.4184 29.427 22.3059 29.2301 22.4072L24.177 24.9788C23.98 25.08 23.8168 25.3614 23.8168 25.6034C23.8168 25.8453 23.98 25.9579 24.177 25.8566L29.2301 23.285C29.427 23.1837 29.5902 22.9024 29.5902 22.6604Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3105 17.0223C30.3105 16.7804 30.1473 16.6678 29.9504 16.7691L23.4567 20.0778C23.2598 20.1791 23.0966 20.4605 23.0966 20.7024C23.0966 20.9444 23.2598 21.057 23.4567 20.9557L29.9504 17.6469C30.1473 17.5457 30.3105 17.2643 30.3105 17.0223Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8305 27.5438C14.8305 27.3019 14.6673 27.1893 14.4704 27.2906L10.1431 29.4964C9.9462 29.5977 9.78302 29.8791 9.78302 30.121C9.78302 30.363 9.9462 30.4755 10.1431 30.3742L14.4704 28.1684C14.6673 28.0671 14.8305 27.7858 14.8305 27.5438Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5507 29.812C15.5507 29.5701 15.3875 29.4575 15.1906 29.5588L10.1375 32.1304C9.94054 32.2317 9.77734 32.513 9.77734 32.755C9.77734 32.9969 9.94054 33.1095 10.1375 33.0082L15.1906 30.4366C15.3875 30.3353 15.5507 30.054 15.5507 29.812Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9912 23.8077C16.9912 23.5658 16.828 23.4532 16.631 23.5545L10.1374 26.8632C9.94045 26.9645 9.77725 27.2459 9.77725 27.4878C9.77725 27.7298 9.94045 27.8424 10.1374 27.7411L16.631 24.4323C16.828 24.3311 16.9912 24.0497 16.9912 23.8077Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5019 12.4244C44.5019 12.1825 44.3387 12.0699 44.1417 12.1712L39.8145 14.377C39.6176 14.4783 39.4544 14.7597 39.4544 15.0016C39.4544 15.2436 39.6176 15.3561 39.8145 15.2549L44.1417 13.049C44.3387 12.9478 44.5019 12.6664 44.5019 12.4244Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5017 15.058C44.5017 14.816 44.3385 14.7035 44.1416 14.8048L39.0885 17.3763C38.8915 17.4776 38.7283 17.759 38.7283 18.0009C38.7283 18.2429 38.8915 18.3555 39.0885 18.2542L44.1416 15.6826C44.3385 15.5813 44.5017 15.3 44.5017 15.058Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5019 9.79102C44.5019 9.54906 44.3387 9.43651 44.1418 9.5378L37.6481 12.8465C37.4512 12.9478 37.288 13.2292 37.288 13.4711C37.288 13.7131 37.4512 13.8256 37.6481 13.7243L44.1418 10.4156C44.3387 10.3143 44.5019 10.033 44.5019 9.79102Z"
        fill={ILLUSTRATION_COLOR_TOKEN_MAP.fill.quaternary}
      />
    </svg>
  );
}
